import _ from 'lodash'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Segment } from 'semantic-ui-react'
import { getFirstObject } from '../common/convert'
import { ParentContext } from '../cnr/contexts/ParentContext'
import { pickAll, pickAllObjects } from '../common/filtering'
import FullPageWrapper from '../wrappers/FullPageWrapper'
import UiSearchFilter from '../pageItem/UiSearchFilter'
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper'
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent'
import { formatItem, formatTypes } from 'global/common/dateFormatting'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'

const WAIT_INTERVAL = 500;

const SearchPage = (props) => {

  const { handleShowSearch } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { eventInfo_state } = states
  const { navigation_fns } = fns

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { fw_info } = framework_state ?? {}
  const { view } = fw_info ?? {}

  const { appDataDocuments } = eventInfo_state ?? {}

  const appDataDocument = useMemo(() => {
    return appDataDocuments?.[view]
  }, [view])


  const [searchValue, updateSearchValue] = useState()
  const [foundItems, setFoundItems] = useState(appDataDocument || null)

  const triggerChange = (value) => {
    if (appDataDocument) {
      if (value) {
        const x = pickAllObjects(value, appDataDocument, ['name', 'lastName', 'firstName'])
        console.log('x', x)
        if (!_.isEmpty(x)) {
          setFoundItems(x)
          return;
        } else {
          setFoundItems(null)
        }
      }
    }
    setFoundItems(appDataDocument)
  }

  const handleClick = (key, itemKey) => {
    handleShowSearch && handleShowSearch()
    navigation_fns.handleNav_item({ key: key }, itemKey)

  }
  const handleSearchChange = (value) => { updateSearchValue(value) }
  const searchHeader = () => <div className={'search-page'}><UiSearchFilter handleSearchChange={handleSearchChange} /></div>

  useEffect(() => {
    if (searchValue) {
      const timer = setTimeout(() => triggerChange(searchValue), WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line
  }, [searchValue]);

  const resultList = (items) => {
    const _items = _.sortBy(items, ['name', 'lastName', 'firstName', 'startDate', 'startTime'])
    const hc = (item) => {
      handleClick(key, item?._itemKey)
    }
    return <Wrapper
      header={_.startCase(view)}
      content={<ItemMenuSquares
        menuItems={_items}
        imsType={_imsTypes.inline}
        noItemIcon={true}
        icon={'list'}
        onClick={hc}
      />}
      wrapperType={wrapperTypes.padded}
    />
  }

  const content = () => <Wrapper
    header={searchHeader()}
    content={foundItems ? resultList(foundItems) : <div></div>}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const searchWizard = () => <FullPageWrapper
    content={content()}
    handleCancel={handleShowSearch}
    topperCaption={`Search ${_.startCase(view)}`}
    css={{ container: 'app-dark-mode' }}
  />

  return searchWizard()
}

export default SearchPage